import { render, staticRenderFns } from "./sqmy.vue?vue&type=template&id=ba31e7f0&scoped=true&"
import script from "./sqmy.vue?vue&type=script&lang=js&"
export * from "./sqmy.vue?vue&type=script&lang=js&"
import style0 from "./sqmy.vue?vue&type=style&index=0&id=ba31e7f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba31e7f0",
  null
  
)

export default component.exports